import React, { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";

import Button from "@components/tailwindComponents/Button";
import Divider from "@components/tailwindComponents/Divider";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";

export default function SalaryInjection({ employeePoste, populateForm }) {
  const { t: translate } = useTranslation(
    "pages.employés.parcours&Certifications"
  );

  const salaryTemplateList = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.salaryTemplates.list
  );

  const salaryTemplateOptions = useMemo(() => {
    return salaryTemplateList.filter(
      (salaryTemplate) => salaryTemplate.linkedPoste === employeePoste?._id
    );
  }, [salaryTemplateList, employeePoste]);

  const [selectedSalaryTemplate, setSelectedSalaryTemplate] = useState(null);
  function handleInject() {
    const { _id, ...selectedSalaryTemplateData } = selectedSalaryTemplate;

    populateForm(selectedSalaryTemplateData);
    setSelectedSalaryTemplate(null);
  }

  return (
    <>
      <div className="arh-mb-6 arh-flex arh-w-full arh-items-end arh-justify-between arh-gap-4">
        <div className="arh-w-full arh-max-w-[26.5rem]">
          <ListboxSimple
            name="salary-template"
            label={translate("Sélectionner l'échelon à charger (facultatif)")}
            placeholder={translate("Sélectionner")}
            optionList={salaryTemplateOptions}
            optionTextAttribut="title"
            selectedValue={selectedSalaryTemplate}
            setSelectedValue={setSelectedSalaryTemplate}
            noRadio
            withSearch
            showReset
          />
        </div>

        <Button
          variant="green"
          className="arh-mb-[1px] !arh-w-auto arh-min-w-[15rem]"
          onClick={handleInject}
          disabled={!selectedSalaryTemplate}
        >
          {translate("Injecter")}
        </Button>
      </div>

      <Divider spaceY="arh-mb-4" />
    </>
  );
}
